import urlBase from 'EstruturaAntiga/assets/urlsBase';
import BaseService from './BaseService';

class PortalDynamicsService extends BaseService {
  constructor() {
    super(urlBase.urlBase + "/dynamics");
  }
}

export default PortalDynamicsService;
